module.exports = __webpack_public_path__ + "img/download.0c5a13a1.jpg";